import { action } from '@/lib/api';
import { store } from '@/redux/lib/configureStore';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors';

/**
 * Submit a tutorial event
 * @param {('run'|'publish'|'info')} event - The tutorial event type
 */
const submitTutorialEvent = (event) => {
  const state = store.getState();

  const tutorialSlug = workflowScreenSelectors.activeWorkflowMetadata(state)?.tutorialSlug;
  if (!tutorialSlug) {
    return;
  }

  action('SET_TUTORIAL_EVENT', event);
};

export default submitTutorialEvent;
